import type { EmployeeSearchSource } from '../../minutes/hooks/useEmployeeSearch'
import { searchAgendaEmployees } from './agendaApi'

/**
 * Ajanda'nın kişi arama ucu (`AGENDA_VIEW` ister); ayrı önbellek anahtarı. Davetliler seçicisi ve yerine
 * katılacak kişi seçicisi (131) ortak kullanır — aynı kişi kümesi, ortak önbellek. Bileşen dosyasında
 * durmaz: oradan sabit dışa açmak hızlı yenilemeyi (react-refresh) bozar.
 *
 * **Yanıt akışında 403 riski — ölçüldü, bugün YOK (03.11.2026).** AI review, `AGENDA_VIEW`'i olmayan
 * bir davetlinin "Katılmayacağım" yanıtında bu aramadan 403 alıp yanıt veremeyeceğini bildirdi.
 * Senaryo mevcut rol kataloğuyla **oluşamıyor**: bu yetki aktif 12 rolün 12'sinde de var (126
 * spec'inde ölçülüp kayda geçti) ve Kısıtlı Yetki izin listesinde de duruyor
 * (`ProxyGrantPolicy.ALLOWED_WHEN_LIMITED`).
 *
 * **Ne zaman gerçek olur:** `AGENDA_VIEW` taşımayan bir rol tanımlanırsa. O gün doğru çare bu ucun
 * yetkisini genişletmek DEĞİL, yanıt akışına davetin kendi kapsamıyla sınırlı dar bir arama ucu
 * açmaktır.
 */
export const AGENDA_SOURCE: EmployeeSearchSource = {
  fetch: (q) => searchAgendaEmployees(q),
  cacheKey: 'agenda-employee-search',
}
